var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.2445 9.35936C-0.0815006 9.72262 -0.0815006 10.2774 0.2445 10.6406L8.36415 19.6883C8.71343 20.0775 9.30804 20.1061 9.69225 19.7523C10.0765 19.3985 10.1048 18.7962 9.75549 18.407L2.21077 10L9.75549 1.59303C10.1048 1.20383 10.0765 0.601499 9.69225 0.247683C9.30804 -0.106133 8.71343 -0.0774503 8.36415 0.311747L0.2445 9.35936Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.d45d8701fa05c0010a44f9603fb0bba5.svg";
export { ForwardRef as ReactComponent };